module.exports = __webpack_public_path__ + "d96f5bfb48dac84cec77b070da764c1b.png";